const th_TH = {
    homepage_title: 'ดาวน์โหลดCalendarTaskเวอร์ชันมือถือด้วย QR code',
    homepage_slogn: 'CalendarTaskเวอร์ชันมือถือ',
    homepage_ios_download: 'App Store กำลังตรวจสอบ...',
    homepage_download: 'ดาวน์โหลด',
    homepage_url_calendar: 'https://image.idesktopcal.com/homepage/calendar_normal_chs.png',
    homepage_url_list: 'https://image.idesktopcal.com/homepage/list_normal_chs.png',
    homepage_url_color: 'https://image.idesktopcal.com/homepage/color_normal_chs.png',

    phonedownload_title: 'ดาวน์โหลดCalendarTaskเวอร์ชันมือถือด้วย QR code',
    phonedownload_slogan: 'ซิงค์กับ PC และแท็บเล็ต จดบันทึกได้ทุกที่',
    phonedownload_send_vip: 'ติดตั้งแอปและรับสมาชิก VIP',
    phonedownload_screenshot: 'ภาพหน้าจอ',
    phodedownload_macos: 'CalendarTaskเวอร์ชัน macOS',
    phodedownload_windows: 'CalendarTaskเวอร์ชัน Windows',
    phodedownload_otherbutton: 'ดูเลย',
    phodedownload_about: 'ติดต่อเรา',
    phodedownload_copyright: '京ICP备18016017号-7',

    feature_no_ad: 'ไม่มีโฆษณา',
    feature_easy: 'มุมมองรายเดือน เรียบง่ายและใช้งานง่าย',
    feature_reminder: 'การแจ้งเตือนที่กำหนดเอง',
    feature_countdown: 'นับถอยหลังวันครบรอบ',

    vip_task_succ: 'สำเร็จ ดาวน์โหลดแอปเพื่อเปิดใช้งาน VIP',
    vip_task_error: 'รับล้มเหลว',

    group_slogn: 'คำเชิญCalendarTaskทีม',

    tt_title: 'CalendarTask',
    tt_share_1: 'แชร์กับคุณ',
    tt_share_2: 'ตารางเรียน',
    tt_share_show_1: 'สแกน QR code ด้วยแอป "CalendarTask" PC และมือถือจะแสดง',
    tt_share_show_2: 'ตารางเรียน',
    tt_share_scan_1: 'สแกนด้วย',
    tt_share_scan_2: 'แอป "CalendarTask"',
    tt_share_succ: 'ซิงค์สำเร็จ',

    v2_copyright: 'ติดต่อ service@xiaoweiyunfu.com<br/>Copyright © 2025 Xiaowei Cloud, Inc. สงวนลิขสิทธิ์',
    v2_download_appstore: 'ดาวน์โหลดบน App Store',
    v2_download_googleplay: 'พร้อมใช้งานบน Google Play',

    v2_main_title: 'CalendarTask มือถือ',
    v2_main_title_part1: 'CalendarTask',
    v2_main_title_part2: 'มือถือ',
    v2_main_description: 'ค้นหา <span class="name">CalendarTask</span> ใน App Store หรือ Google Play',
    v2_download_ios: 'ดาวน์โหลด iOS',
    v2_download_android: 'ดาวน์โหลด Android',
    v2_download_harmonyos: 'ดาวน์โหลด HarmonyOS',
    v2_sync_status: 'ซิงค์เสร็จสิ้น! อัปโหลด 1 รายการ ดาวน์โหลด 0 รายการ',
    v2_feature_title: 'ซิงค์ข้อมูลหลายอุปกรณ์',
    v2_feature_description: 'ซิงค์ระหว่างมือถือ แท็บเล็ต และ PC'
};
export default th_TH;
